// slider (splide)
(() => {
  // get sliders on page
  // .media-overlay-splide ausgenommen: der Slider im Overlay wird von
  // media-overlay.js selbst gemountet, erst wenn der Dialog offen und damit
  // messbar ist.
  const slidersOnPage = document.querySelectorAll( '.splide:not(.media-overlay-splide)' );
  if(slidersOnPage[0]) {
    for ( var i = 0; i < slidersOnPage.length; i++ ) {
      const splide = new Splide( slidersOnPage[ i ], {
        focus           : 'center',
        // pagination      : false,
        type            : 'loop',
        pagination: false
      });
      // init slider
      splide.mount();
      // execute before slider is moved
      splide.on( 'move', function () {
        // stop any running media player
        document.querySelectorAll('audio, video').forEach((media) => {
          if (!media.paused) {
            media.pause();
          }
        });
      });
    }
  }
})();